<div class="app-toast-container" [class.active]="data.visible"
    [class.error]="data.type === 'error'"
    [class.warning]="data.type === 'warning'"
    [class.info]="data.type === 'info'" (click)="hide()">
    <div class="app-toast-icon">
        <svg-icon src="assets/images/icon-exclamation-circle.svg"
            fill="var(--danger)"
            *ngIf="data.type === 'error'"></svg-icon>
        <svg-icon src="assets/images/icon-exclamation-triangle.svg"
            fill="var(--secondary)"
            *ngIf="data.type === 'warning'"></svg-icon>
        <svg-icon src="assets/images/icon-check-filled.svg"
            fill="var(--main-light)"
            *ngIf="data.type === 'info'"></svg-icon>
    </div>

    <div class="app-toast-message">
        <p class="app-toast-title">{{data.title}}</p>
        <p class="app-toast-text">{{data.message}}</p>
    </div>

    <div class="app-toast-close">
        <svg-icon src="assets/images/icon-times.svg"></svg-icon>
    </div>
</div>